import { type ReactNode } from 'react'
import { Navigate } from 'react-router'
import { useAuthStore } from '@/features/auth'

interface RequireRoleProps {
    roles: string[]
    children: ReactNode
}

const RequireRole = ({ roles, children }: RequireRoleProps) => {
    const { userProfile } = useAuthStore()
    const hasRole = roles.some((r) => userProfile?.roles.includes(r))

    if (!hasRole) {
        return <Navigate to="/" replace />
    }

    return children
}

export default RequireRole
